import { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";

function NormalTable(props) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const PrintFunc = () => {
    window.print();
  };

  useEffect(() => {
    if (props.isPrint === true) {
      handlePrint();
      props.close();
    }
  }, [props.isPrint]);
  const tabStyle = {};

  return (
    <div className="main_popup">
      <div style={tabStyle}>
        <table
          className="fullTablePrint"
          style={{ width: "50%", padding: "50px" }}
          ref={componentRef}
        >
          {props.headData ? (
            <thead>
              {props.headData.map((item, index) => (
                <th>{item}</th>
              ))}
            </thead>
          ) : null}

          <tbody>
            {props.bodyData &&
              props.bodyData.map((item, index) =>
                props.renderBody(item, index)
              )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default NormalTable;
